import { CoreTheme } from '../core';
import { breakpoints, fontSizes, radii, space, zIndices } from './scales';

export const theme: CoreTheme = {
  breakpoints,
  fontSizes,
  radii,
  space,
  zIndices,
  variants: {},
};

export default theme;
